import { combineReducers } from 'redux';

import getReserveHistoryReducer from './getReserveHistoryReducer';
import reserveHistoryDetailStateReducer from './state/reserveHistoryDetailStateReducer';
import getReserveHistoryDetailReducer from './getReserveHistoryDetailReducer';
import putCancelReserveReducer from './putCancelReserveReducer';

const index = combineReducers({
  getReserveHistory: getReserveHistoryReducer,
  reserveHistoryDetailState: reserveHistoryDetailStateReducer,
  getReserveHistoryDetail: getReserveHistoryDetailReducer,
  putCancelReserve: putCancelReserveReducer,
});

export default index;
